import React, { useContext, useEffect } from 'react';
import Input from '@mui/material/Input';
import Select from '@mui/material/Select';
import MenuItem from '@mui/material/MenuItem';
import FormHelperText from '@mui/material/FormHelperText';
import FormControl from '@mui/material/FormControl';
import DataContext from '../../../../../context/DataProvider/DataContext';

interface Props {
  value: number | undefined | string;
  onValueChange: (value: number | unknown) => void;
}

function TaxEditor({ value, onValueChange }: Props): JSX.Element {
  const { tax, loaderFun } = useContext(DataContext);

  useEffect(() => {
    loaderFun.loadTax();
  }, []);

  return (
    <FormControl fullWidth error>
      <Select
        input={<Input />}
        value={value}
        onChange={(event) => onValueChange(event.target.value)}
        style={{ width: '100%' }}
        error={!value}
      >
        {tax.map((taxItem) => (
          <MenuItem key={taxItem.id} value={taxItem.code}>
            {taxItem.percent}% : {taxItem.code}
          </MenuItem>
        ))}
      </Select>
      <FormHelperText>{value ? '' : 'Incorrect entry'}</FormHelperText>
    </FormControl>
  );
}
export default TaxEditor;
